import { render, staticRenderFns } from "./MeasureUnitAdd.form.vue?vue&type=template&id=986b1306&"
import script from "./MeasureUnitAdd.form.vue?vue&type=script&lang=js&"
export * from "./MeasureUnitAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports